import React from "react";
import "../styles/AboutUs.css";
import brushBackground from "../assets/brushBackground.png";
import platformLogos from "../assets/platformLogos.png";
import mobileLogos from "../assets/about-us-mobile.png";
// Import icons
import serviceIcon1 from "../assets/fractional-cmo-icon.png";
import serviceIcon3 from "../assets/customer-acquisition-icon.png";
import serviceIcon2 from "../assets/email-icon.png";
import serviceIcon4 from "../assets/creative-strategy-icon.png";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <section className="section-container2">
      <div className="about-us">
        {/* Content Wrapper */}
        <div className="about-content">
          {/* Title */}
          <div className="about-title">
            <h2>
              <span className="about-main-text">What We</span>
              <span className="about-highlight">DO</span>
            </h2>
          </div>

          {/* Services Section */}
          <div className="services-section">
            <div className="service">
              <img
                src={serviceIcon1}
                alt="Service Icon 1"
                className="service-icon"
              />
              <p>Fractional CMO Services</p>
            </div>
            <div className="service">
              <img
                src={serviceIcon2}
                alt="Service Icon 2"
                className="service-icon"
              />
              <p>Email and SMS Marketing</p>
            </div>
            <div className="service">
              <img
                src={serviceIcon3}
                alt="Service Icon 3"
                className="service-icon"
              />
              <p>Customer Acquisition Strategy</p>
            </div>
            <div className="service">
              <img
                src={serviceIcon4}
                alt="Service Icon 4"
                className="service-icon"
              />
              <p>Creative Strategy and Consultation</p>
            </div>
          </div>
        </div>

        {/* Description */}
        <p className="about-description">
          We specialize in data-driven marketing strategies designed to{" "}
          <strong id="description-strong">accelerate business growth</strong>.
          Our testing-first approach ensures every marketing effort, from
          customer acquisition strategies to email and SMS campaigns, is
          optimized for measurable results. Whether you need creative
          consultation or a tailored growth plan,{" "}
          <strong id="description-strong">
            we focus solely on delivering strategies that drive sustainable
            revenue and maximize ROI
          </strong>
          . We leverage every tool at our disposal—from industry-leading
          platforms to advanced analytics—to ensure your marketing efforts
          achieve unparalleled success.
        </p>

        {/* Logos Section */}
        <div className="logos-section">
          <img
            src={brushBackground}
            alt="Brush Background"
            className="brush-background desktop"
          />
          <img
            src={platformLogos}
            alt="Platform Logos"
            className="platform-logos desktop"
          />
          <img
            src={mobileLogos}
            alt="Platform Logos Mobile"
            className="platform-logos-mobile"
          />
        </div>

        {/* Call-to-Action */}
        <div className="about-us-cta">
          <p className="about-us-cta-text">
            Click below to Schedule Your FREE Growth Audit!
          </p>
          <Link to="/lead-form" className="about-us-cta-button">
            Get Started
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
